import * as React from 'react';
import { connect } from 'react-redux';
import { useOidcAuth } from '@shared/auth';
import { Avatar } from '@shared/ui-components';
import { ThemesDialogModal } from 'common/components/page-header-avatar/themes-dialog-modal';

import { State } from 'common/interfaces/state';
import { AccountApi } from '../../../units/account/api';
import { PageHeaderAvatarMenu } from './page-header-avatar-menu';
import { Styled } from './styled';

const SIZE = 60;

interface StateProps {
  firstName: string;
  lastName: string;
  userId: string;
  email: string;
  isAdminPage?: boolean;
  hasAvatar: boolean;
}

interface Props extends StateProps { }

const PageHeaderAvatarComponent: React.FC<Props> = ({
  firstName,
  lastName,
  email,
  isAdminPage,
  userId,
  hasAvatar,
}) => {
  const [isProfileDropDownOpened, setIsProfileDropDownOpened] = React.useState(false);
  const { signOut } = useOidcAuth();

  const avatarUrl = AccountApi.getAvatarLink({ id: userId, hasAvatar });
  const fullName = `${firstName} ${lastName}`;

  const toggleDropDown = React.useCallback(() => {
    setIsProfileDropDownOpened((prev) => !prev);
  }, []);

  return (
    <Styled.Container className='page-header-avatar'>
      <ThemesDialogModal />
      <Styled.AvatarContainer size={SIZE}>
        <Avatar
          name={fullName}
          size={SIZE}
          avatar={avatarUrl}
          onClick={toggleDropDown}
        />
      </Styled.AvatarContainer>
      {isProfileDropDownOpened && (
        <PageHeaderAvatarMenu
          isAdminPage={isAdminPage}
          fullName={fullName}
          userName={email}
          logOut={signOut}
          onClose={toggleDropDown}
        />
      )}
    </Styled.Container>
  );
};


const mapStateTopProps = (state: State): StateProps => {
  const { firstName, lastName, id, email, hasAvatar } = state.account;
  return {
    firstName,
    lastName,
    userId: id,
    email,
    isAdminPage: state.router.location.pathname.startsWith('/admin'),
    hasAvatar,
  };
};


export const PageHeaderAvatar = connect(mapStateTopProps)(PageHeaderAvatarComponent);

